import { APIService } from "services";

export const getVw_Samithi_Members = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllVw_Samithi_Members(pageNo,pageSize);
    }
    else{
        try {
            res = await searchVw_Samithi_Members(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const getAllVw_Samithi_Members = (pageNo,pageSize) => {
return APIService.api().get(`/vw_samithi_members/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneVw_Samithi_Members = (samithi_member_id) => {
return APIService.api().get(`/vw_samithi_members/${samithi_member_id}`)
}
export const searchVw_Samithi_Members = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/vw_samithi_members/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
